module.exports = __webpack_public_path__ + "static/media/colored-leaves.d5334ec7.jpg";